import { HIDE_MODAL, SHOW_MODAL } from "../../constants/actions";

export const showChangePassModal = () => ({
  type: SHOW_MODAL,
});

export const hideChangePassModal = () => ({
  type: HIDE_MODAL,
});
